import { Component, inject } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ItauRecorrenciaResponse } from 'src/app/admin-api';

@Component({
  selector: 'app-cobrancas-recorrentes-modal',
  templateUrl: './cobrancas-recorrentes-modal.component.html',
  styleUrl: './cobrancas-recorrentes-modal.component.scss'
})
export class CobrancasRecorrentesModalComponent {
  recurrence: ItauRecorrenciaResponse =
    inject(DynamicDialogConfig).data?.recurrence;
}
